<template>
  <v-app v-resize="onResize">
    <side-nav-left :side-nav="sideNav" :active-user="users.active"
                    @updateSideNav="val => toggleNav(val)"></side-nav-left>
    <top-nav @toggleNav="toggleNav()" :show-notifications="showNotifications"></top-nav>
    <login :visible="users.loggedIn" @update="toggleLoginDialog()"></login>
    <v-img
            style="min-height: 100vh;position: fixed; width: 100vw;z-index: 0;"
            :src="coverImg"
    ></v-img>
    <v-content style="z-index: 1;">
<div class="v-content__wrap" style="min-height:100vh;">
      <router-view>
        <v-container fluid class="mb-5 pb-5"></v-container>
      </router-view>
</div>
      <my-footer class="mt-5" @showDsgvo="dsgvoVis=true"></my-footer>
      <analytics @showNotifications="val => showNotifications = true" @showDsgvo="dsgvoVis=true"></analytics>
      <dsgvo  :visible="dsgvoVis" @closeDsgvo="dsgvoVis=false" ></dsgvo>
    </v-content>

  </v-app>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import TopNav from "./components/nav/topNav/NavTop";
    import Login from "./components/login/Login";
    import Notifications from "./components/content/notifications/Notifications";
    import SideNavLeft from "./components/nav/sideNavLeft/LeftNav";
    import MyFooter from "./components/Footer/footer";
    import Analytics from "./components/ga/Analytics";
    import Dsgvo from "./components/pages/DSGVO";
    import {Resize, Scroll} from 'vuetify/es5/directives'

    export default {
        components: {
            Dsgvo,
            Analytics,
            MyFooter,
            SideNavLeft,
            Notifications,
            Login,
            TopNav,
        },
        directives: {
            Resize, Scroll
        },
        data() {
            return {sideNav: true, showLogin: false, showNotifications: false, dsgvoVis: false};
        },
        computed: {
            ...mapGetters(['users']),
            coverImg() {
                return "/static/img/bg-images/image" +
                    Math.floor((Math.random() * 4) + 1) +
                    ".jpg"
            }
        },
        methods: {
            ...mapActions(['getAllSliders', 'getAllUsers', 'getAllNews', 'logIn', 'getAllComments', 'toggleLoginDialog', 'setMobile']),
            onResize() {
                this.setMobile(window.innerWidth < 900);
            },
            toggleNav(val) {
                if(val !== undefined) this.sideNav = val
                else this.sideNav = !this.sideNav
            }
        },
        created() {
            // do something after creating vue instance
            // console.log('app created');
            this.getAllSliders();
            this.getAllNews();
            this.getAllComments();
            this.onResize()
            if (this.$auth.isAuthenticated()) {
                let userName = localStorage.getItem('userName');
                this.getAllUsers(() => {
                    this.logIn({
                        userName,
                        cb: (activeUser) => {
                            this.$http.put(this.$helper.apiUrl() + '/users/' + activeUser.id, activeUser)
                        }
                    }); // update login date
                });
            }
            this.$router.beforeEach((to, from, next) => {
                if (!to.matched.length) {
                    next('/notfound');
                } else {
                    next();
                }
            });

        },
    };
</script>
